import React, { useState, useRef } from "react";

const YouTubeEmbed = ({ videoId, isMuted, onToggleMute }) => {
  const [loopCount, setLoopCount] = useState(0);
  const videoRef = useRef(null);

  return (
    <div className="h-full w-full relative rounded-t-lg overflow-hidden flex-shrink-0">
      <iframe 
        ref={videoRef}
        width="100%" 
        height="100%" 
        src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=${isMuted ? 1 : 0}&controls=0&showinfo=0&rel=0&modestbranding=1&iv_load_policy=3&disablekb=1&fs=0&loop=1&playlist=${videoId}`}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        className="absolute top-0 left-0"
        onLoad={() => {
          // Reset loop count when video loads
          setLoopCount(0);
        }}
      />
      
      {/* Simple mute/unmute button only */}
      <button 
        className="absolute bottom-2 xs:bottom-3 sm:bottom-4 right-2 xs:right-3 sm:right-4 bg-black bg-opacity-50 text-white p-1.5 xs:p-2 rounded-full z-10 hover:bg-opacity-70 transition-all"
        onClick={onToggleMute}
      >
        {isMuted ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" className="xs:w-5 xs:h-5 sm:w-5 sm:h-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M10 1L6 5H2v6h4l4 4V1z"></path>
            <line x1="17" y1="3" x2="8" y2="12"></line>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" className="xs:w-5 xs:h-5 sm:w-5 sm:h-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M10 1L6 5H2v6h4l4 4V1z"></path>
            <path d="M14 5a4 4 0 0 1 0 6"></path>
            <path d="M17 3a7 7 0 0 1 0 10"></path>
          </svg>
        )}
      </button>
    </div>
  );
};

export default YouTubeEmbed;